import React, { useMemo, useState, useEffect } from 'react'
import {Button} from "ellow-web-ui-components-library";
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { FormInput } from '../../../wrappers/formInput';
import {FromHead} from "ellow-web-ui-components-library";
import Styles from "./styles.module.scss";
import * as CONSTANTS from '../../../utils/CONSTANTS';
import { RadioInput } from '../../../wrappers/radioInput';
import DurationRadio from '../../../compopnents/durationRadio';
import { Error } from "@progress/kendo-react-labels";
import FormHead from "../../../compopnents/headings/FromHead";
import { Icon } from '@iconify/react';
import PlacesAutocomplete, {  geocodeByAddress } from 'react-places-autocomplete';
interface Props {

  ClickHandler: any
  Back: (event: React.MouseEvent<HTMLButtonElement>) => void
  defaultValues: {
    website: string,
    workWithRemote: number,
    size: number,
    googleLocations: any
    // skills: {id: number, name: string}[],
  }
  emailId: string
  customerId: string | undefined;
  disable?: boolean;
  userId: string;
  status: any;
  isExistingCustomer: boolean
}

export type JobDetailsFormFields = {
  website: string;
  workWithRemote: number;
  size: number;
};


const validationSchema = Yup.object({
  website: Yup.string()
    .required("Field is required")
    // eslint-disable-next-line no-useless-escape
    .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-zA-Z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,'Please Provide a valid company address'),
  workWithRemote: Yup.number()
    .required("Field is required")
})


const JobDetails: React.FC<Props> = ({
  ClickHandler,
  Back,
  defaultValues,
  emailId,
  customerId,
  disable,
  userId,
  isExistingCustomer
}) => {

  const { v4: uuidv4 } = require('uuid');
  const [error,setError] = useState<{ workWithRemote?: string, size?: string, locationError?: string}>({workWithRemote:'', size:'', locationError: ''})
  const [durationState, setDurationState] = useState<number>(0)
  const [address, setAddress] = useState('')
  const [locationArray, setLocationArray] = useState<{id:string, name:string}[]>([])
  const [locationError , setLocationError ] = useState<any>()
  
  
  const formOptions = { resolver: yupResolver(validationSchema),defaultValues:useMemo(() => {
    return defaultValues;
  }, [defaultValues]) };


  const {
    register,
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm<JobDetailsFormFields>(formOptions);

  useEffect(() => {  
      
    reset(defaultValues)
    setDurationState(defaultValues.size)
    setLocationArray(defaultValues.googleLocations ? defaultValues.googleLocations : [])
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues])

  useEffect(() => {

    window.scrollTo(0,0)
    
  }, [ ])

  const onSubmit = (data:any) => {
    
    delete data.firstName
    delete data.companyName
    delete data.designation
    delete data.phoneNumber
    delete data.skills
    delete data.workEmail
    delete data.linkedinId
    delete data.profileUrl
    delete data.currencyType

    data.workWithRemote = parseInt(data.workWithRemote)
    data.size = parseInt(data.size)
    let isError = false;
 
    if(data.workWithRemote === 5){
     error.workWithRemote = "Select atleast one option"
     isError=true;
    }

    if(data.size === 5){
      error.size = "Select atleast one option"
      isError=true;
    }

    if(locationArray.length === 0 ){
      error.locationError = "Select atleast one location"
      isError = true
    }else{
      data.googleLocations = locationArray
    }
      
    const value:any = {
      customerId: customerId,
      customerStatus: 2,
      companyType: 1,
      customerMetadata: data,
      submittedBy: 'CUSTOMER',
      userId: userId,
      isExistingCustomer: isExistingCustomer
    } 
    if(!isError){
      ClickHandler(value) 
    }
  }

  const handleChnage = (e: any, name: any) => {
    
    if (name === 'size'){
      delete error.size
      setValue(name, e.target.value) 
      setDurationState(e.target.value)   
    }
    if(name === 'workWithRemote') {
      delete error.workWithRemote
      setValue(name, e.value)  
 
    }
    setError({...error})
  }

  const handleSelect = async (value: any) => {
    
    delete error.locationError
    const results = await geocodeByAddress(value);
    let data = {
      "id": uuidv4(),
      "name": results[0].formatted_address
    }  
    if(locationArray.length > 4 ){
      error.locationError = 'Maximum five locations are allowed'
      setError({ ...error})
    }else{
      setLocationArray([...locationArray, data])
      setAddress('')
    } 
  }

  const removeLocation = (item: any) => {
    
    delete error.locationError
    const index = locationArray.findIndex(findItem => findItem.id === item.id); 
    locationArray.splice(index, 1);
    setLocationArray([...locationArray])
  }

  return (
    <div>
        <form className={Styles.comnpanyForm}>
            <FromHead>Are you okay to work with remote developers?*</FromHead>
            <RadioInput<JobDetailsFormFields>
              data = {CONSTANTS.remoteWork}
              layout ='horizontal'
              name="workWithRemote"
              handleChange={(e: any) => handleChnage(e, 'workWithRemote')}
              checked={1}
              register={register}
              errors={errors}
              control={control}
            />
          <Error>{error?.workWithRemote}</Error>
            <br></br>
            <FromHead>Current employees in your company*</FromHead>
            <div className={Styles.durationCheck}>
            <DurationRadio 
              name='size'
              label='Short Term'
              value={0}
              handleChange={(e: any) => handleChnage(e, 'size')}
              duration='1-10'
              // eslint-disable-next-line eqeqeq
              checked={durationState == 0 ? true : false}
            />
            <DurationRadio
              name='size'
              label='Medium Term'
              value={1}
              handleChange={(e: any) => handleChnage(e, 'size')}
              duration='11-50' 
              // eslint-disable-next-line eqeqeq
              checked={durationState == 1 ? true : false}
            />
            <DurationRadio 
              name='size'
              label='Long Term'
              value={2}
              handleChange={(e: any) => handleChnage(e, 'size')}
              duration='51-250'
              // eslint-disable-next-line eqeqeq
              checked={durationState == 2 ? true : false}
            />
            <DurationRadio 
              name='size'
              label='Long Term'
              value={3}
              handleChange={(e: any) => handleChnage(e, 'size')}
              duration='251-10k'
              // eslint-disable-next-line eqeqeq
              checked={durationState == 3 ? true : false}
            />
            <DurationRadio 
              name='size'
              label='Long Term'
              value={4}
              handleChange={(e: any) => handleChnage(e, 'size')}
              duration='10k+'
              // eslint-disable-next-line eqeqeq
              checked={durationState == 4 ? true : false}
            />
            </div>
            <Error>{error?.size}</Error>
             <br></br>
            {/* <FromHead>Which skills are you looking for?</FromHead>
            <div className={Styles.tagLabelWrap}>
              {getAddedSkills().map((skill, key) => <TagLabel label={skill.name}
                key={key}
                value={skill.id}
                checked={getDefaultSkills(skill)}
                handleChange={(e: any) => skillChange(e, skill)} />)}

              {skillOthers && <div className={Styles.tagDropdown}>
                <Combodropdown
                  placeholder="Please search your skill"
                  data={skills}
                  name='name'
                  id='id'
                  handleChange={(value: { name: string, id: number }) => skillChange("addValue", value)}
                />
              </div>}
              <Error>{error}</Error>
            </div> */}
             
            {/* <FromHead>How many developers are you planning to hire?  </FromHead>
            <p className={Styles.experienceWrap}>
              <div className="form-group">
              <FormInput<JobDetailsFormFields>
              id="developerCount"
              type="number"
              name="developerCount"
              placeholder=""
              onchange={(e:any) => e.target.value = e.target.value ? Math.abs(e.target.value) : ''}
              // defaultValue={defaultValues.developerCount}
              register={register}
              errors={errors}
              />
              </div>
            </p> */}
            {/* <FromHead>How soon do you expect the developer/s to join you?</FromHead>
            <RadioInput<JobDetailsFormFields>
              data = {CONSTANTS.availabilityRadio}
              layout ='horizontal'
              name="availability"
              handleChange={(e: any) => handleChnage(e, 'availability')}
              checked={1}
              register={register}
              errors={errors}
              control={control}
            /> */}
            <div className="half-form-wrap">
              <div className="form-group">
                <FormInput<JobDetailsFormFields>
                    id="companyWebsite"
                    type="text"
                    name="website"
                    label="Company Website*"
                    placeholder="Company Website"
                    register={register}
                    errors={errors}
                  />
                </div>
            </div>
            <div className={Styles.subHeadWrap}>
              <FormHead>Locations</FormHead>
            </div>
            <div className='preference-form-wrapper'>
              <div className="form-group">
                { <PlacesAutocomplete
                  value={address}
                  onChange={setAddress}
                  onSelect={handleSelect}
                >
                {({getInputProps, suggestions, getSuggestionItemProps, loading}) => (
                  <div className="search-filed">
                    <Icon icon="carbon:search"/>
                    <input
                      {...getInputProps({
                      placeholder: 'Search Places ...',
                      className: 'location-search-input field',
                      })}
                    />
                    { suggestions && suggestions.length > 0 && 
                      <div  className="suggestion-list">
                        { loading ? <div className="suggestion-item">...loading</div> : null }
                        {suggestions.map(suggestion => {
                          return (
                            <div {...getSuggestionItemProps(suggestion)} className="suggestion-item">
                              {suggestion.description}
                            </div>
                          )
                        })}
                      </div>
                    }
                  </div>
                )}
                </PlacesAutocomplete>}
                <Error>{error.locationError}</Error>
              </div>
            </div>
            <ul className={Styles.addressList}>
              {locationArray && locationArray.map((item: any) => {
                return (
                  <li>
                    <Icon icon="ep:location" className={Styles.location} />
                    <div className={Styles.addressLine}>
                      <div>{item.name}</div>
                      <div className={Styles.addressAction}>
                        <Icon icon="icon-park-outline:delete" onClick={() => removeLocation(item)}/>
                      </div>
                    </div>
                  </li>
                )
              })}
            </ul>
            <div className={Styles.formAction}>
              <Button variant='secondary' onClick ={Back}>Back</Button>
              <Button variant='primary' onClick={handleSubmit(onSubmit)} disabled={disable}>Complete Registration</Button>
            </div>
        </form>
    </div>
  )
}

export default JobDetails;